import { formatLinkProperties } from '@cx-web/utils/formatLinkProperties';

import styles from './FooterOC.module.css';

export type GeneralLinkProps = {
  link?: string;
  name: string;
  onClick?: (e: React.MouseEvent) => void;
  showSeparator: boolean;
};

const Separator = ({ show }: { show: boolean }) => (show ? <span className={styles.separatorDot}>·</span> : null);

export const FooterLink = ({ link, name, onClick, showSeparator }: GeneralLinkProps): JSX.Element => {
  return (
    <li className={styles.standardLinksListItem} key={name.toLowerCase()}>
      <Separator show={showSeparator} />
      {onClick ? (
        <button
          aria-label={`Open ${name}`}
          className={styles.standardLink}
          data-testid="general-link"
          onClick={onClick}
          type="button"
        >
          {name}
        </button>
      ) : link ? (
        <a className={styles.standardLink} data-testid="general-link" {...formatLinkProperties(link)}>
          {name}
        </a>
      ) : null}
    </li>
  );
};
